import {Component, TemplateRef, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {environment} from "../../../environments/environment";

@Component({
  selector: 'app-link-account',
  standalone: true,
  imports: [],
  templateUrl: './link-account.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './link-account.component.scss'
})
export class LinkAccountComponent {

  @ViewChild('content', { static: true })
  content!: TemplateRef<any>

  constructor(private modalService: NgbModal) {
  }

  public show() {
    this.modalService.open(this.content, { ariaLabelledBy: 'modal-basic-title' }).result.then(
      (result) => {
      },
      (reason) => {
      },
    );
  }

  linkPatreon() {
    window.location.href = environment.patreonUrl;
  }

  linkGoogle() {
    window.location.href = environment.googleUrl;
  }
}
